import React from 'react';
import { Redirect } from 'react-router-dom';

import routes from '../config/routes';

const NotFoundRoute = () => <Redirect to={routes.JOBS} />;

export default NotFoundRoute;
